import React from 'react';
import {Checkbox} from '@blueprintjs/core';

import {useSelectReports} from '../hooks';

interface SelectAllProps {
}

export const SelectAll = ({}: SelectAllProps) => {
  /*
   * This component is used to select all reports in the list.
   * - If all reports are selected, check the checkbox
   *   - on click, uncheck all
   * - If some reports are selected, show the indeterminate state
   *   - on click, select all
   * - If no reports are selected, uncheck the checkbox
   *   - on click, select all
   */
  const {allSelected, someSelected, onChange} = useSelectReports();

  return (
    <Checkbox
      label=""
      name="select_all_reports"
      checked={allSelected}
      indeterminate={!allSelected && someSelected}
      onChange={() => onChange(!allSelected)}
    />
  )
};

export const renderSelectAll = (): any => {
  /*
   * This function is used to render the SelectAll component in the list header.
   * This way we can add this code into a .ts file.
   */
  return (
    <SelectAll />
  );
};
